const jquery = require('jquery');
module.exports = window.jQuery = window.$ = jquery;
